import Template from '../../component/Template.js';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';

import useAutd from '../../component/useAuth.js';
import { Link } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

export default function CourseView() {


  const [coursedata, setCourseData] = useState([]);
  const [outcomedata, setOutcomeData] = useState([]);

  const [courseComponents, setCourseComponents] = useState([]);
  const [courseCreditHoursData, setCourseCreditHoursData] = useState({});
  const [creditHours, setCreditHours] = useState({});
  const [message, setMessage] = useState(false);
  const [discipline, setDisciplineData] = useState([]);
  const [faculty, setFacultyData] = useState([]);
  const [remarks, setRemarks] = useState("");
  const status = "active";
  const { http } = Api();
  let { id } = useParams();
  const decodedID = atob(id);
  sessionStorage.setItem("id", decodedID);
  const navigate = useNavigate();

  useEffect(() => {
    const { http } = Api();
    const id1 = sessionStorage.getItem("id");


    const fetchData = async () => {
      try {

        const response = await http.get(`/Admin/getCourseDetailsById/${id1}`);        
      
        setCourseData(response.data.Course);
        setOutcomeData(response.data.Outcome);
        setCourseComponents(response.data.CourseComponents || []);
        setCreditHours(response.data.CreditHours || {});
        setCourseCreditHoursData(response.data.CourseCreditHoursData || {});
      

      } catch (error) {

        setMessage("somtding went wrong");
        console.error('Error fetching discipline data:', error);

      }
    };

    fetchData();

  }, []);

  const codeToKey = {
    L: 'lecture',
    T: 'tutorial',
    PCP: 'practicum',
    PLP: 'practical',
    FW: 'fieldwork',
    S: 'seminar',
    A: 'assignment',
    O: 'OJT',
    INT: 'internship',
  };

  const isAutd = useAutd();

  if (isAutd === false) {
    navigate("/admin/")
  }
  return (
    <>
      <ToastContainer />
      <Template>
        <div className="card-body">
          <div className="container-fluid">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12" >
                  <div className="card">

                    <div className="card-body">
                      <div className="card-body pdg1 box">
                        <div className="table-responsive">
                          {coursedata.length === 0 ? (
                            <p>No Data Available...</p> // Or any loading indicator
                          ) : (
                            <>
                              <div>
                                <h3 className="">Course Details</h3>
                                <div className="br mar3"></div>
                                <table className="display tab1 table-bordered">
                                  <tbody>
                                    <tr>
                                      <td>Course Code</td>
                                      <td>:</td>
                                      <td width="50%">{coursedata[0].course_code}</td>

                                    </tr>
                                    <tr>
                                      <td>Course Title</td>
                                      <td>:</td>
                                      <td>{coursedata[0].course_name}</td>


                                    </tr>
                                    <tr>
                                      <td>Faculty Name</td>
                                      <td>:</td>
                                      <td>{coursedata[0].faculty_name}</td>


                                    </tr>
                                    <tr>
                                      <td>Discipline Name</td>
                                      <td>:</td>
                                      <td>{coursedata[0].discipline_name}</td>

                                    </tr>
                                    <tr>
                                      <td>Semester</td>
                                      <td>:</td>
                                      <td>{coursedata[0].semester_name}</td>

                                    </tr>
                                    <tr>
                                      <td>Course Component Type</td>
                                      <td>:</td>
                                      <td width="50%">{coursedata[0].course_discipline_component_code}</td>

                                    </tr>
                                    <tr>
                                      <td>Course type</td>
                                      <td>:</td>
                                      <td>{coursedata[0].coursetype}</td>

                                    </tr>
                                    {coursedata[0].coursetype === 'P' && coursedata[0].practical_type != '' && (
                                      <tr>
                                        <td>Practical type</td>
                                        <td>:</td>
                                        <td>{coursedata[0].practical_type}</td>

                                      </tr>
                                    )}
                                    <tr>
                                      <td>Credit</td>
                                      <td>:</td>
                                      <td>{coursedata[0].credit}</td>
                                      {/* <td>{coursedata[0].coursetype != false && (


                                     
                                        
                                            <div className="row">
                                              {(coursedata[0].coursetype === 'T' || coursedata[0].coursetype === 'B') && (
                                                <div className="col-md-2 m-2 ">
                                                  <input type="text" className="form-control" id="lecture" name="lecture" placeholder="Theory"  Value={coursedata[0].credit_theory} disabled  />
                                                </div>
                                              )}
                                              {(coursedata[0].coursetype === 'P' || coursedata[0].coursetype === 'B') && (
                                                <div className="col-md-2 m-2 ">
                                                  <input type="text" className="form-control" id="tutorial" name="tutorial" placeholder="Practical"  Value={coursedata[0].credit_practical} disabled />
                                                </div>
                                              )}


                                              <div className="col-md-2 m-2 ">
                                                <input type="text" className="form-control" id="total" name="total" placeholder="Total" Value={coursedata[0].credit} disabled />
                                              </div>

                                            </div>
                                         
                                      )}</td> */}

                                    </tr>
                                    <tr>
                                      <td>Selected Course Components </td>
                                      <td>:</td>
                                      <td width="">{coursedata[0].concatenated_course_components}</td>

                                    </tr>
                                    {/* <tr>
                                      <td>Lecture, Tutorial, Practical Credit Ratio <br />Credit Distribution (L:T:P)</td>
                                      <td>:</td>
                                      <td width="">{coursedata[0].credit_lecture} : {coursedata[0].credit_tutorial} : {coursedata[0].credit_practical}</td>

                                    </tr> */}

                                    {/* Credit and Hours Section end */}

                                    {courseComponents.map(component => {
                                      const key = codeToKey[component.course_component_code];
                                      if (!key) return null;

                                      return (
                                        <tr key={component.id}>
                                          <td style={{ paddingLeft: '25px' }}>
                                            {component.course_component} (Credit / Hours)
                                          </td>
                                          <td>:</td>
                                          <td>
                                            {creditHours[`${key}_credit`] ?? 0} / {creditHours[`${key}_hours`] ?? 0}
                                          </td>
                                        </tr>
                                      );
                                    })}

                                    <tr style={{ fontWeight: "bold", background: "#f1f5f9" }}>
                                      <td style={{ paddingLeft: '25px' }}>Total hours</td>
                                      <td>:</td>
                                      <td>{courseCreditHoursData.total_hours ?? 0}</td>
                                    </tr>

                                    {/* Credit and Hours Section end */}

                                    <tr>
                                      <td>Level of course</td>
                                      <td>:</td>
                                      <td>{coursedata[0].course_level}</td>

                                    </tr>
                                    <tr>
                                      <td>No: of Outcomes</td>
                                      <td>:</td>
                                      <td>{coursedata[0].outcome_number}</td>

                                    </tr>
                                    <tr>
                                      <td>Remarks</td>
                                      <td>:</td>
                                      <td>{coursedata[0].remarks}</td>

                                    </tr>


                                  </tbody>

                                </table>


                              </div>

                              <h5 id="Mark_Details" className="pdg3">Mark Details</h5>
                              <div className="mb-3 row">
                                <div className="container box1">
                                  <div className="row g-4">
                                    {(coursedata[0].coursetype === 'T' || coursedata[0].coursetype === 'B') && (
                                      <>
                                        <div className="col-md-6">
                                          <div className="border rounded p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                              <label className="form-label fw-bold mb-0">Theory Internal</label>
                                              <div className="form-check form-switch">

                                              </div>
                                            </div>
                                            <div className="row g-2">
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Min"
                                                  name="theoryMin"
                                                  disabled
                                                  id='theoryMin'
                                                  defaultValue={coursedata[0].TI_MIN}
                                                />
                                              </div>
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Max"
                                                  name="theoryMax"
                                                  disabled
                                                  id='theoryMax'
                                                  defaultValue={coursedata[0].TI_MAX}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-6">
                                          <div className="border rounded p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                              <label className="form-label fw-bold mb-0">Theory External</label>
                                              <div className="form-check form-switch">

                                              </div>
                                            </div>
                                            <div className="row g-2">
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Min"
                                                  name="theoryExternalMin"
                                                  disabled
                                                  id='theoryExternalMin'
                                                  defaultValue={coursedata[0].TE_MIN}
                                                />
                                              </div>
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Max"
                                                  name="theoryExternalMax"
                                                  disabled
                                                  id='theoryExternalMax'
                                                  defaultValue={coursedata[0].TE_MAX}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}

                                    {(coursedata[0].coursetype === 'P' || coursedata[0].coursetype === 'B') && (
                                      <>
                                        <div className="col-md-6">
                                          <div className="border rounded p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                              <label className="form-label fw-bold mb-0">Practical Internal</label>
                                              <div className="form-check form-switch">


                                              </div>
                                            </div>
                                            <div className="row g-2">
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Min"
                                                  name="practicalInternalMin"
                                                  disabled
                                                  id='practicalInternalMin'
                                                  defaultValue={coursedata[0].PI_MIN}
                                                />
                                              </div>
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Max"
                                                  name="practicalInternalMax"
                                                  disabled
                                                  id='practicalInternalMax'
                                                  defaultValue={coursedata[0].PI_MAX}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-6">
                                          <div className="border rounded p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                              <label className="form-label fw-bold mb-0">Practical External</label>
                                              <div className="form-check form-switch">

                                              </div>
                                            </div>
                                            <div className="row g-2">
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Min"
                                                  name="practicalExternalMin"
                                                  disabled
                                                  defaultValue={coursedata[0].PE_MIN}
                                                  id='practicalExternalMin'
                                                />
                                              </div>
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Max"
                                                  name="practicalExternalMax"
                                                  disabled
                                                  defaultValue={coursedata[0].PE_MAX}
                                                  id='practicalExternalMax'
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>




                              <h6 className='mt-3'>CO Statements</h6>
                              <table className="display table table-bordered" border="1">
                                <thead>
                                  <th>CO No.</th>
                                  <th>State the Course Outcomes</th>
                                  <th>Corresponding Learning Domain</th>
                                  <th>Corresponding PO Nos</th>

                                </thead>
                                <tbody>
                                  {outcomedata.slice(0, coursedata[0].outcome_number).map((outcome, index) => (
                                    <tr key={index}>
                                      <td>{outcome.outcome_slno}</td>
                                      <td>{outcome.outcome_description}</td>
                                      <td>{outcome.concatenated_learning_domains}</td>
                                      <td>{outcome.concatenated_programme_outcomes}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>

                            </>
                          )}



                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </Template>
    </>
  );
}
